/**
 * Simple global unsaved changes flag management.
 * Use these functions to track if the user has unsaved work.
 */

// Initialize the global flag
if (typeof window !== 'undefined') {
    window.__VRTTA_UNSAVED_CHANGES__ = false;
}

const DIRTY_KEY = 'vrtta_is_unsaved_work_active';

/**
 * Marks whether there are unsaved changes.
 * @param {boolean} isDirty - True if there are unsaved changes, false otherwise.
 */
export const setUnsavedChanges = (isDirty) => {
    if (typeof window !== 'undefined') {
        window.__VRTTA_UNSAVED_CHANGES__ = !!isDirty;

        // Sync to localStorage so other tabs know we have unsaved work
        if (isDirty) {
            localStorage.setItem(DIRTY_KEY, 'true');
        } else {
            localStorage.removeItem(DIRTY_KEY);
        }

        // Dispatch a custom event
        window.dispatchEvent(new CustomEvent('vrttaUnsavedChangesChanged', { detail: !!isDirty }));
    }
};

/**
 * Checks if there are unsaved changes in THIS tab or ANY other tab.
 * @returns {boolean} - True if there are unsaved changes anywhere.
 */
export const hasUnsavedChanges = () => {
    if (typeof window !== 'undefined') {
        // Check local flag first (fastest)
        if (window.__VRTTA_UNSAVED_CHANGES__) return true;

        // Check localStorage (covers other tabs)
        return localStorage.getItem(DIRTY_KEY) === 'true';
    }
    return false;
};
